import { DEFAULT_MODE, makeThemeColor, PRIMARY } from '@tornado-rdk/theme';
import { FULL_HD, HD } from '@bedrock-rdk/constants';
import { getFont, FONT } from '@tornado-rdk/typography';
import { makeDefaultStylingContext } from '../../utils/style';
import { makeStepsTemplate } from '../pairing.utils';
import { Button } from '../../button/button.component';
import { middle } from '../../utils/sizes';

export const defaultContext = makeDefaultStylingContext();

export const colors = {
  text: makeThemeColor(PRIMARY),
};

export const CODE_SIZE = {
  [HD]: 208,
  [FULL_HD]: 274,
};

export const STEPS_MARGIN_LEFT = {
  [HD]: 32,
  [FULL_HD]: 40,
};

export const STEPS_GAP = {
  [HD]: 24,
  [FULL_HD]: 32,
};

export const getInitialStyle = ({ screenSize = FULL_HD, colorMode = DEFAULT_MODE } = defaultContext) => {
  const titleFont = getFont(FONT.PARIS_2, screenSize);

  return {
    flex: {
      direction: 'column',
    },
    Title: {
      text: {
        ...titleFont,
        textColor: colors.text[colorMode],
        maxLines: 2,
        maxLinesSuffix: '...',
        verticalAlign: 'middle',
      },
      flexItem: {
        marginBottom: 24,
      },
    },
    Content: {
      flex: {
        direction: 'column',
      },
      CodeContainer: {
        flex: {
          direction: 'row',
        },
        Code: {
          w: CODE_SIZE[screenSize],
          h: CODE_SIZE[screenSize],
        },
        Steps: {
          flex: {
            direction: 'column',
          },
          flexItem: {
            marginLeft: STEPS_MARGIN_LEFT[screenSize],
          },
          ...makeStepsTemplate(5, {
            flexItem: {
              marginBottom: STEPS_GAP[screenSize],
            },
          }),
        },
      },
      Button: {
        flexItem: {
          marginTop: STEPS_GAP[screenSize],
        },
        visible: false,
        type: Button,
        label: '',
        mountX: 0.5,
        x: middle,
      },
    },
  };
};
